"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCollateralAccountStats = void 0;
const generateReceivableStats_1 = require("./generateReceivableStats");
const getCollateralAccountStats = (collateralAccounts) => {
    const stats = (0, generateReceivableStats_1.generateReceivableStats)(collateralAccounts.flatMap((acct) => acct.receivables));
    return stats;
};
exports.getCollateralAccountStats = getCollateralAccountStats;
//# sourceMappingURL=getCollateralAccountStats.js.map